// components/BackToAlbums.tsx
import React from 'react';
import { Link } from 'react-router-dom';

type BackToAlbumsProps = {
	albumId?: string;
};

const BackToAlbums: React.FC<BackToAlbumsProps> = ({ albumId }) => {
	return (
		<Link
			to={albumId ? `/albums/${albumId}/photos` : '/albums'}
			className="inline-flex items-center px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-all duration-200 font-medium text-sm rounded-lg"
		>
			← Back to {albumId ? 'Album' : 'Albums'}
		</Link>
	);
};

export default BackToAlbums;
